module.exports = __webpack_public_path__ + "static/media/om_eyeshape_upturned_blue.2044da56.png";